
import { computed, defineComponent, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import SimpleTable from '@/components/table/simple/SimpleTable.vue'
import { ElCollapse } from 'element-plus'
import resize from '@/layout/resize'
import { formatThousands } from '@/utils'

type SimpleTableRef = {
  getSelectionRows: () => any[]
  clearSelection?: () => void
}

export default defineComponent({
  name: 'DynamicCollapse',
  components: {
    SimpleTable
  },
  methods: { formatThousands },
  props: {
    groups: {
      type: Array,
      required: true,
      default: () => []
    },
    columnStruct: {
      type: Array,
      required: true
    },
    tableHadSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    listLoading: {
      type: Boolean,
      required: false,
      default: false
    },
    defaultAllActive: {
      type: Boolean,
      required: false,
      default: true
    },
    defaultActive: {
      type: Array,
      default: () => []
    },
    selectable: {
      type: Function,
      required: false,
      default: () => true
    }
  },
  // 定义 v-model
  emits: ['update:groups'],
  setup(props) {
    const { t } = useI18n()
    const collapseRef = ref(ElCollapse)
    const tableList = ref()
    const { isMobile } = resize()
    const isMobileDevices = computed(() => {
      return isMobile()
    })
    const activeNames = computed<any[]>(() => {
      if (props.defaultAllActive) {
        return Array.from(props.groups.keys()) || []
      } else {
        return props.defaultActive
      }
    })

    // 存储所有 SimpleTable 实例的 ref
    const simpleTableRefs = ref<InstanceType<typeof SimpleTable>[]>([])

    // 设置 ref 的方法
    const setChildRef = (el: InstanceType<typeof SimpleTable> | null, index: number) => {
      if (el) {
        simpleTableRefs.value[index] = el
      } else {
        simpleTableRefs.value[index] = null as any
      }
    }

    // 获取所有选中行
    const getSelectionRows = () => {
      const allSelectedRows: any[] = []
      const selectedRowsByGroup: Record<number, any[]> = {}

      simpleTableRefs.value.forEach((tableRef, index) => {
        if (tableRef && typeof (tableRef as any).getSelectionRows === 'function') {
          try {
            const rows = (tableRef as any).getSelectionRows()
            if (rows && rows.length > 0) {
              allSelectedRows.push(...rows)
              selectedRowsByGroup[index] = rows
            }
          } catch (error) {
            console.error(`获取第 ${index} 个表格的选中行失败:`, error)
          }
        }
      })

      return {
        allRows: allSelectedRows,
        byGroup: selectedRowsByGroup,
        totalCount: allSelectedRows.length
      }
    }

    // 监听 groups 变化，更新 ref 数组长度
    watch(() => props.groups, (newGroups) => {
      simpleTableRefs.value = new Array(newGroups.length).fill(null)
    }, { immediate: true })

    return {
      t,
      collapseRef,
      setChildRef,
      tableList,
      activeNames,
      isMobileDevices,
      getSelectionRows
    }
  }
})
